import { Injectable } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Injectable({ providedIn: 'root' })
export class LoaderService {

  private requestCount = 0;

  constructor(private loader: NgxUiLoaderService) {}

  show() {
    this.requestCount++;
    this.loader.start();
  }

  hide() {
    this.requestCount--;
    if (this.requestCount <= 0) {
      this.requestCount = 0;
      this.loader.stop();
    }
  }
}
